import { useAuth } from '@Context/CognitoAuthProvider';
import { CognitoIDToken } from '@Models/types';
import { SignOut, UserCircle, UserGear } from '@phosphor-icons/react';
import { jwtDecode } from 'jwt-decode';
import { NavLink } from 'react-router-dom';

const AccountDropdown = () => {
  const { user, logout } = useAuth();
  const hideAccountDropdown = () => {
    const dropdown = document.getElementById('account-dropdown');
    if (dropdown) {
      dropdown.classList.toggle('flex');
      dropdown.classList.add('hidden');
    }
  };

  const logoutUser = async () => {
    logout();
  };

  const username = user?.profile?.email
    ? user?.profile?.email
    : localStorage.getItem('email');
  const decode = jwtDecode(
    localStorage.getItem('idToken') || ''
  ) as CognitoIDToken;
  const name = decode.given_name;
  const isAdmin = user?.admin;

  return (
    <div
      id="account-dropdown"
      onMouseLeave={() => hideAccountDropdown()}
      className="absolute right-0 top-10 z-50 hidden flex-col items-start rounded-b-lg border-b border-l border-r border-neutral-400 bg-white p-5 shadow-md"
    >
      <span className="flex flex-row items-center justify-center gap-2">
        <UserCircle size={45} weight="thin" />
        <span className="flex flex-col">
          <span className="font-bold text-neutral-700">{name}</span>
          <span className="text-xs text-primary-600">{username}</span>
        </span>
      </span>

      {isAdmin && (
        <div className="mt-2 flex w-full items-center justify-center rounded-md bg-primary-700 px-2 py-1 text-xs font-bold text-white">
          ADMIN
        </div>
      )}

      <NavLink
        to="/profile"
        className="mt-6 flex w-full cursor-pointer flex-row gap-2 border-l-4 border-neutral-300 px-2 py-1 text-primary-600 hover:border-primary-700 hover:bg-primary-100"
      >
        <span>
          <UserGear size={20} weight="regular" />
        </span>
        <span className="text-sm">Manage Account</span>
      </NavLink>

      <span
        onClick={() => logoutUser()}
        className="mt-2 flex w-full cursor-pointer flex-row gap-2 border-l-4 border-neutral-300 px-2 py-1 text-primary-600 hover:border-primary-700 hover:bg-primary-100"
      >
        <span>
          <SignOut size={20} weight="regular" />
        </span>
        <span className="text-sm">Sign Out</span>
      </span>
    </div>
  );
};

export default AccountDropdown;
